import React from 'react';
import ComplexServicesTable from './Components/ComplexServicesTable';

const ComplexServicesPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ComplexServicesTable />
      </div>
    </div>
  );
};

export default ComplexServicesPage;
